import { createAction } from '@reduxjs/toolkit';

export const storeAPIError = createAction<string | null>('global/storeApiError');
